import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  input,
  output,
} from '@angular/core';
import { Kopfau, KopfauWithMetadata } from '../../types/kopfau';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'soft-dashboard-card',
  templateUrl: './dashboard-card.component.html',
  styleUrls: ['./dashboard-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
})
export class DashboardCardComponent {
  detailPressed = output<void>();
  statusChanged = output<string>();

  auftrag = input<KopfauWithMetadata>();
  highlighted = input<boolean>(false);
  firstInGroup = input<boolean>(false);
  lastInGroup = input<boolean>(false);
  saving = input<boolean>(false);

  get primaryActionStyle(): Partial<CSSStyleDeclaration> {
    let color = 'var(--colorPrimary)';

    if (this.auftrag()?.metadata?.updating) {
      color = 'rgba(120, 120, 120, 0.9)';
      return { color, borderRadius: '100%' };
    }

    if (this.auftrag()?.kopfau?.status !== 'PAUSIERT') {
      color = 'var(--colorError)';
    }

    if (this.auftrag()?.kopfau?.status === 'ABGESCHLOSSEN') {
      color = 'var(--colorSuccess)';
    }

    return { color };
  }

  get primaryActionIcon(): string {
    let iconName = 'fa-play-circle';

    if (this.auftrag()?.kopfau.status !== 'PAUSIERT') {
      iconName = 'fa-stop-circle';
    }

    if (this.auftrag()?.kopfau?.status === 'ABGESCHLOSSEN') {
      iconName = 'fa-check-circle';
    }

    return iconName;
  }

  constructor(private elementRef: ElementRef) {}

  scrollIntoView(): void {
    this.elementRef.nativeElement?.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });
  }

  emitStatusChange(): void {
    const newStatus =
      this.auftrag()?.kopfau.status === 'PAUSIERT' ? 'GESTARTET' : 'PAUSIERT';
    this.statusChanged.emit(newStatus);
  }

  emitDetailNavigation(): void {
    this.detailPressed.emit();
  }
}
